import { HistoryOutlined } from '@ant-design/icons';
import { Button, Table, Tooltip } from 'antd';
import DownloadComponent from 'components/Global/Download';
import Ellipse from 'components/Global/Ellipse';
import { useSelector } from 'react-redux';
import { formatDate, invalidText } from 'utils/utils';

const { Column } = Table;

type Props = {
	nhimaLatestData: any;
	isLoading: boolean;
	showModal: () => void;
	totalRecords: number;
};

const ShareComponent = (data: any) => {
	const { record } = data;

	return (
		<Tooltip
			title={
				<>
					<p>EmployeeShare: {record.employeeShare} %</p>
					<p>EmployerShare: {record.employerShare} %</p>
				</>
			}
			placement="right"
			overlayInnerStyle={{ width: 'fit-content', height: 'fit-content' }}
		>
			{record.employerShare + record.employeeShare} %
		</Tooltip>
	);
};
	const renderAgeDetails = (record: any) => {
		const details = (
			<div>
				<p>
					<strong>Age limit :</strong>{' '}
					{record.ageLimit ? `${record.ageLimit} years` : '-'}
				</p>
			</div>
		);

		return (
			<Tooltip title={details}>
				<Button type="link"  style={{color:'#584495'}}>View Details</Button>
			</Tooltip>
		);
	}

const NhimaLatestTable = (props: Props) => {
	const { nhimaLatestData, isLoading, showModal, totalRecords } = props;

	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);

	return (
		<div>
			<Table
				dataSource={nhimaLatestData}
				rowKey={(record) => record.id}
				loading={isLoading}
				pagination={false}
			>
				<Column
					title="Effective Date"
					dataIndex="effectiveDate"
					key="effectiveDate"
					className="bg-white"
					width={150}
					render={(value) => {
						return formatDate(
							value,
							profileData?.companyDateFormat ?? 'DD/MM/YYYY'
						);
					}}
				/>
				<Column
					title="Percentage Share"
					key="percentageShare"
					className="bg-white"
					width={200}
					render={(text, record: any) => (
						<ShareComponent record={record} />
					)}
				/>
				<Column
					title="Updated By"
					dataIndex="createdBy"
					key="createdBy"
					className="bg-white"
					width={150}
					render={(text) => text?.fullName}
				/>
				<Column
					title="Notes"
					dataIndex="notes"
					key="notes"
					className="bg-white"
					width={200}
					render={(text) =>
						invalidText(text) ? (
							'-'
						) : (
							<Ellipse
								message={text}
								maxLength={20}
								key={text}
								tooltipMessage={text}
								isTooltip={true}
							/>
						)
					}
				/>
				<Column
					title="Attachment"
					dataIndex="attachment"
					key="attachment"
					className="bg-white"
					width={'18%'}
					render={(text, record: any) => (
						<div>
							{record.documentName ? (
								<div>
									<DownloadComponent
										documentUrl={record.documentUrl}
										showTooltip={true}
										downloadText={record.documentName}
										text={record.documentName}
										isLink={true}
										maxLength={20}
									/>
								</div>
							) : (
								'-'
							)}
						</div>
					)}
				/>
				<Column
					title="Other Details"
					dataIndex="createdAt"
					key="createdAt"
					className="bg-white"
					width={'16%'}
					render={(text, record: any) =>
						renderAgeDetails(record)
					}
				/>
				{totalRecords >= 1 && (
					<Column
						title="History"
						dataIndex="history"
						key="history"
						className="bg-white"
						width={100}
						render={() => (
							<Button
								type="link"
								icon={<HistoryOutlined />}
								onClick={showModal}
							/>
						)}
					/>
				)}
			</Table>
		</div>
	);
};

export default NhimaLatestTable;
